<template>
  <page-outline :title="$t('Webheader.ocr_templates')">
    <template slot="pageContent">
      <!-- <div class="layoutTop"></div> -->
      <div class="overflow-hidden">
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div class="mt-0">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else class="overflow-x-unset">
                  <!-- ACTION BUTTONS BEGIN -->
                  <f7-list class="mb-2">
                    <f7-list-item>
                      <b-row class="justify-content-start">
                        <!-- <b-col cols="3">
                          <b-button class="btn btnFilter"
                            @click="displayFilter = !displayFilter">
                            <i v-if="displayFilter" class="fa-light fa-minus"></i>
                            <i v-else class="fa-light fa-plus"></i>
                          </b-button>
                        </b-col> -->
                        <b-col cols="3">
                          <b-button class="btn btnFilter"
                            @click="refreshInbox()">
                            <i class="fa-light fa-rotate-right"></i>
                          </b-button>
                        </b-col>
                        <!-- Right section filtre -->
                        <b-col>
                          <b-button class="btn btnFilter_2"
                            @click="exportTemplates()">
                            <i class="fa-light fa-upload"></i>
                            <span class="fab-label">{{ $t('common.extract_list') }}</span>
                          </b-button>
                        </b-col>

                        <!-- <b-col cols="4" offset="8" class="d-flex flex-row-reverse" v-if="displayFilter" style="margin-top:5px;">
                        </b-col> -->
                      </b-row>
                    </f7-list-item>
                  </f7-list>
                  <!-- ACTION BUTTONS BEGIN -->

                  <!-- LIST BEGIN -->
                  <b-table responsive
                  hover borderless outlined class="table mt-3 text-center"
                  v-if="templatesList.length"
                  :items="templatesList"
                  :fields="fields"
                  :sort-by="sortField">
                    <template #cell(active)="data" :title="data.value.active">{{data.value.active}}
                      <div v-if="data.value ==='0'"><i class="fa-duotone fa-xmark btn btn-icon btn-icon-red"></i></div>
                      <div v-else-if="data.value === '1'"><i class="fa-duotone fa-warning btn btn-icon btn-icon-orange"></i></div>
                      <div v-else-if="data.value === '2'"><i class="fa-duotone fa-check btn btn-icon btn-icon-green"></i></div>
                    </template>
                    <template #cell(id_account)="data"><i class="fa-light fa-list" @click="activateDetail(data.value)"></i></template>
                    <template #cell(edit)="data"><i class="fa-light fa-pencil cursor" @click="activateEdit(data.value)"></i></template>
                    <template #cell(delete)="data"><i class="fa-light fa-trash" @click="activateDelete(data.value)"></i></template>
                  </b-table>
                  <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('common.no_result') }}
                    </span>
                  </div>
                  <!-- LIST END -->
                  <b-row class="justify-content-end mt-5">
                    <b-col lg="2" offset="7" class="mt-3">
                      <b-button
                      @click="addTemplate" variant="primary">
                        <i class="fa-light fa-plus fs-17px"></i>
                        <span>{{$t('administration.ocrtemplate_add')}}</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import Pagination from '@/components/common/pagination.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'OCRTemplateListPage',
  components: {
    'cm-pagination': Pagination,
    'page-outline': PageOutline
  },
  props: {
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
    return {
      activateSpinner: false,
      fields: [
        { key: 'active', label: this.$t('administration.active_enable'), class: 'text-center' },
        { key: 'identifier', label: this.$t('common.idtfr'), class: 'text-center' },
        { key: 'name', label: this.$t('common.user'), class: 'text-center' },
        { key: 'email_reference', label: this.$t('common.eml_adrs'), class: 'text-center' },
        { key: 'id_account', label: this.$t('common.dtls'), class: 'text-center'},
        { key: 'edit', label: this.$t('rights.edit'), class: 'text-center' },
        { key: 'delete', label: this.$t('common.del_label'), class: 'text-center' }
      ],
      sortField: '',
      templatesList: []
    }
  },
  created () {
  },
  mounted () {
    console.log(this.$engine.ocr.templates.fetch())
    // this.$engine.ocr.templates.fetch()
  },
  beforeDestroy () {
    let that = this
  },
  methods: {
    addTemplate () {
      let that = this
      loadPage(that, {url: '/ocrtemplate_add/'})
    },
    exportTemplates () {
    },
    onInfinite () {
      if (this) {
        return
      }
    },
    refreshInbox () {
    }
  }
}

</script>
